module.exports = __webpack_public_path__ + "static/media/arrow-up.43adc2b7.svg";